import Vue from 'vue'
import Vuex from 'vuex'
import common from 'gclife-common-front/lib/store'

// vuex State管理对象
const state = {
  dic: {}     // 字典
}

// mutations事件， 由actions执行提交commit()
const mutations = {
  CHANG_DIC(state, dic) { state.dic = dic }
}

// actions提交
const actions = {
  changDic({commit}, dic) { commit('CHANG_DIC', dic) }
}

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common
  },
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js